import { z, ZodSchema } from "zod";
import { UseFormReturn } from "react-hook-form";
import { FieldType, Form } from "@shared/features/form/Form";
import { PasswordRequirementsContainer } from "../PasswordRequirements/PasswordRequirementsContainer";

export type Props = {
  fields: FieldType[];
  form: UseFormReturn<z.infer<ZodSchema>>;
};

export function ResetPasswordForm({ fields, form }: Props) {
  const { isSubmitting, isLoading, isValid, errors } = form.formState;

  return (
    <>
      <Form
        fields={fields}
        form={form}
        className="w-full"
        innerClassName="justify-center"
        errorContainerClassName="p-0 mt-8"
      >
        <PasswordRequirementsContainer />
      </Form>
    </>
  );
}

export default ResetPasswordForm;
